import * as yup from 'yup';

export const CreateTeacherRequiredDocumentFormValidation = yup.object().shape({
    description: yup.string().required('Tipo de documento é obrigatório')
});